import { render } from "./MapaEstoqueIndex.vue?vue&type=template&id=dc6b1eb4&ts=true"
import script from "./MapaEstoqueIndex.vue?vue&type=script&lang=ts"
export * from "./MapaEstoqueIndex.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__